import { useStore } from '@/store';

export const getReportColumnPresetsState = () => {
  const store = useStore();

  return {
    savedColumns: store.savedColumns,
    savedGroups: store.savedGroups,
    activePreset: store.activePreset,
    savedColumnsInCurentPreset: store.savedColumnsInCurentPreset,
  };
};
